import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ea332ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "footer"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, " IceCreemSearch ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | THEME MADE BY ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://n0ts.top",
  target: "_blank"
}, "N0ts", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://beian.miit.gov.cn",
    target: "_blank"
  }, "湘ICP备20005603号-2")
], -1))

import { ref } from "vue";
import data from "@/data/data";

// 页脚年份

export default /*#__PURE__*/_defineComponent({
  __name: 'footer',
  setup(__props) {

const time = ref(new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  return (_unref(data).saveData.footerText)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(data).saveData.bgLinkHref && _unref(data).saveData.bgLinkContent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: _unref(data).saveData.bgLinkHref,
                  target: "_blank"
                }, _toDisplayString(_unref(data).saveData.bgLinkContent), 9, _hoisted_3)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, "© " + _toDisplayString(time.value), 1),
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ]),
          _hoisted_7
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})